export default function UserSettingIcon() {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.90625 19.2491C1.82834 17.6531 3.1542 16.3278 4.75064 15.4064C6.34708 14.485 8.15788 14 10.0011 14C11.8444 14 13.6552 14.4851 15.2516 15.4065C16.848 16.3279 18.1739 17.6533 19.0959 19.2493M16.751 5.75V6.875M16.751 5.75C17.5795 5.75 18.251 5.07843 18.251 4.25C18.251 3.42157 17.5795 2.75 16.751 2.75M16.751 5.75C15.9226 5.75 15.251 5.07843 15.251 4.25C15.251 3.42157 15.9226 2.75 16.751 2.75M16.751 2.75V1.625M18.0501 5L19.0243 5.5625M15.452 5L14.4777 5.5625M18.0501 3.5L19.0243 2.9375M15.452 3.5L14.4777 2.9375M15.4973 10.4103C15.0484 11.4318 14.3235 12.3078 13.404 12.9399C12.4845 13.572 11.4069 13.935 10.2924 13.9882C9.17785 14.0413 8.07059 13.7826 7.0951 13.2409C6.1196 12.6993 5.31454 11.8962 4.77044 10.9221C4.22633 9.94797 3.96477 8.84136 4.01514 7.72671C4.06552 6.61206 4.42584 5.53356 5.0556 4.61248C5.68535 3.6914 6.55957 2.96426 7.57995 2.51281C8.60033 2.06137 9.72642 1.90352 10.8316 2.05702"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
